// src/components/Footer/Footer.js
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Stack,
} from '@mui/material';
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  Phone,
  Email,
  LocationOn,
} from '@mui/icons-material';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              About East Fort Holidays
            </Typography>
            <Typography variant="body2">
            Surrounded by trees and natural beauty, our cozy resort offers a peaceful getaway. Take a refreshing dip in our pool or simply relax while enjoying the calm forest atmosphere.
            </Typography>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn />
                <Typography variant="body2">
                J64R+FP6 Killannur, Kerala, Near Poomala Dam,  Thrissur
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone />
                <Typography variant="body2">+91 9847005764</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email />
                <Typography variant="body2">info@eastfortholidays.com</Typography>
              </Box>
            </Stack>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              <Link href="/rooms" color="inherit" underline="hover">
                Our Rooms
              </Link>
              <Link href="/amenities" color="inherit" underline="hover">
                Amenities
              </Link>
              <Link href="/contact" color="inherit" underline="hover">
                Contact
              </Link>
              <Link href="/booking" color="inherit" underline="hover">
                Book Now
              </Link>
            </Stack>
          </Grid>
        </Grid>

        {/* Social Media Links */}
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <IconButton color="inherit">
            <Facebook />
          </IconButton>
          <IconButton color="inherit">
            <Twitter />
          </IconButton>
          <IconButton color="inherit">
            <Instagram />
          </IconButton>
          <IconButton color="inherit">
            <LinkedIn />
          </IconButton>
        </Box>

        {/* Copyright */}
        <Typography
          variant="body2"
          align="center"
          sx={{ mt: 2 }}
        >
          © {new Date().getFullYear()} East Fort Holidays. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;